export default {
  title: 'Verifique su identidad',
  subtitle: 'Ingrese los últimos 4 dígitos del teléfono del paciente o del número de pedido para ver los detalles de la entrega.',
  'type-phone': 'Teléfono del paciente (últimos 4 dígitos)',
  'type-order': 'Número de pedido (últimos 4 dígitos)',
  code: 'Últimos 4 dígitos',
  submit: 'Continuar',
  'attempts-remaining': 'Intentos restantes: {count}',
  blocked: 'Demasiados intentos. Inténtelo de nuevo en {minutes} min.',
  'invalid-code': 'Código incorrecto. Inténtelo de nuevo.',
  expired: {
    title: 'Enlace expirado',
    description: 'El acceso a este pedido ya no está disponible (límite de 14 días).',
  },
  forbidden: {
    title: 'Acceso denegado',
    description: 'No tiene permiso para ver esta página.',
  },
}
